/** @jsxImportSource @emotion/react */
import Box from '@mui/material/Box';
import MuiButton from '@mui/material/Button';

/**
 * Prev/next arrows for a paged track. Desktop-only (the style hides them on
 * mobile, where the user swipes). Shared by the day row and the time row.
 */
export const PagerArrows = ({
  classes,
  currentPage,
  pageCount,
  goToPage,
  previousLabel,
  nextLabel,
  testIdPrefix,
}) => (
  <Box css={classes.pagerArrows}>
    <MuiButton
      css={classes.pagerArrow}
      onClick={() => goToPage(currentPage - 1)}
      disabled={currentPage === 0}
      data-testid={`${testIdPrefix}Prev`}
      aria-label={previousLabel}
    >
      ‹
    </MuiButton>
    <MuiButton
      css={classes.pagerArrow}
      onClick={() => goToPage(currentPage + 1)}
      disabled={currentPage === pageCount - 1}
      data-testid={`${testIdPrefix}Next`}
      aria-label={nextLabel}
    >
      ›
    </MuiButton>
  </Box>
);

/**
 * Page dots for a paged track. Mobile-only (the style hides them on desktop).
 * pageKeys carries one stable key per page (its first item's id), so each dot
 * has a real key rather than its array index.
 */
export const PagerDots = ({ classes, currentPage, pageKeys, testIdPrefix }) => (
  <Box css={classes.pagerDots}>
    {pageKeys.map((pageKey, pageIndex) => (
      <Box
        key={pageKey}
        css={[
          classes.pagerDot,
          pageIndex === currentPage && classes.pagerDotOn,
        ]}
        data-testid={`${testIdPrefix}Dot-${pageIndex}`}
        aria-current={pageIndex === currentPage}
      />
    ))}
  </Box>
);
